import { stripLocalePrefix } from './strip-locale-prefix';

const PRIVATE_PATH_SEGMENTS = [
  '/sys',
  '/my',
  '/account',
  '/dashboard',
  '/login',
  '/signup',
  '/logout',
  '/signout',
  '/welcome',
  '/connect',
];

export function shouldHideOnPrivatePath(pathname: string): boolean {
  const path = stripLocalePrefix(pathname);
  return PRIVATE_PATH_SEGMENTS.some((seg) => path === seg || path.startsWith(`${seg}/`));
}
